import { PRESET_RANGES } from "../../utils/format";
import { useReportFilters } from "../../contexts/ReportFiltersContext";

const DateRangePicker = () => {
  const {
    rangeKey,
    setRangeKey,
    customFrom,
    customTo,
    setCustomFrom,
    setCustomTo,
    isRangeValid,
  } = useReportFilters();

  const showCustom = rangeKey === "custom";
  const invalidCustom = showCustom && !isRangeValid;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="inline-flex bg-gray-100 rounded-md p-0.5">
        {PRESET_RANGES.map((p) => (
          <button
            key={p.key}
            type="button"
            onClick={() => setRangeKey(p.key)}
            className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
              rangeKey === p.key
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600 hover:text-gray-800"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>

      {showCustom && (
        <div className="flex items-center gap-1.5 text-xs text-gray-600">
          <span>Từ</span>
          <input
            type="date"
            value={customFrom}
            max={customTo}
            onChange={(e) => setCustomFrom(e.target.value)}
            className={`px-2 py-1 text-xs border rounded ${
              invalidCustom ? "border-red-400" : "border-gray-200"
            } focus:outline-none focus:ring-1 focus:ring-blue-400`}
          />
          <span>đến</span>
          <input
            type="date"
            value={customTo}
            min={customFrom}
            onChange={(e) => setCustomTo(e.target.value)}
            className={`px-2 py-1 text-xs border rounded ${
              invalidCustom ? "border-red-400" : "border-gray-200"
            } focus:outline-none focus:ring-1 focus:ring-blue-400`}
          />
          {invalidCustom && (
            <span className="text-red-500">Khoảng ngày không hợp lệ</span>
          )}
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
